import { registerServiceWorker } from './registerSW';
export const serviceWorker = registerServiceWorker();
